<template>
  <div>
    <vue-pull-refresh :onRefresh="reload">
    <div @click="openDateDialog">
      <DatePager :date="date" @addDay="addDay" @subtractDay="subtractDay" />
    </div>
    <v-tabs v-model="tabIndex" color="primary" grow>
      <!-- <v-tab v-if="shouldShowAttendance">出欠</v-tab> -->
      <!-- <v-tab v-if="shouldShowMemo">メモ一覧</v-tab> -->
      <v-tab value="attendance">出欠</v-tab>
      <v-tab value="memo">メモ一覧</v-tab>
    </v-tabs>

    <!-- 出欠サマリー -->
    <div class="d-flex mt-5" v-if="chatSummary">
      <div class="attendance-summary-block" style="flex: 1;">
        <div class="attendance-label-small">現在の園児人数</div>
        <div class="attendance-label-medium my-2">
          <span class="attendance-label-large">{{
            chatSummary ? (chatSummary.presentChildrenCount - chatSummary.leftChildrenCount) : 0
          }}</span>
          人/{{ chatSummary ? chatSummary.totalChildrenCount : 0 }}人
        </div>
      </div>
      <div style="flex: 1;" @click="absenceDialog = true">
        <div class="attendance-label-small">お休み</div>
        <div class="my-2 d-flex justify-center align-center">
          <div class="attendance-label-medium">
            <span class="attendance-label-large">{{ chatSummary.absences.length }}</span>
            人
          </div>
        </div>
      </div>
    </div>

    <v-tabs-window v-model="tabIndex" :show-arrows="false" :touchless="true"> 
      <v-tabs-window-item value="attendance"> 
        <div v-if="!fetchLoading && clasSummary">
          <v-list v-for="(clas, index) in clasSummary" :key="index" density="compact"> 
            <v-list-subheader class="attendance-list-header d-flex align-center w-100"> 
              {{ clas.className }}
              <span v-if="clas.isInCharge" class="text-primary ml-6">担当クラス</span>
              <span class="ml-6">{{ (clas.presentChildrenCount - clas.leftChildrenCount) }}/{{ clas.totalChildrenCount }}</span>
            </v-list-subheader>
            <v-list-item
              v-for="(attendance, index) in clas.childrenAttendance"
              :key="index"
              :to="`/communication/chat/${attendance.child.childId}?date=${date.toISOString()}`"
            >
              <div class="d-flex align-center justify-space-between w-100">
                <div>
                  <template v-if="predictFever(attendance.isFeverAlert)">
                    <v-icon>mdi-emoticon-sick</v-icon>
                  </template>
                  {{ attendance.child.lastName }} {{ attendance.child.firstName }}
                  
                  <template v-if="attendance.status === 1">
                    <v-chip color="primary" class="mx-2" variant="outlined" size="small">登園済み</v-chip>
                  </template>
                  <template v-if="attendance.status === 2">
                    <v-chip color="secondary" class="mx-2" variant="outlined" size="small">降園済み</v-chip>
                  </template>
                  <template v-if="attendance.absence === 1">
                    <v-chip color="grey" class="mx-2" variant="outlined" size="small">おやすみ</v-chip>
                  </template>
                  <template v-if="attendance.pickup">
                    <template v-if="attendance.pickup.dropOff.by || attendance.pickup.pickup.by">
                      <v-chip color="orange" class="mx-2" variant="outlined" size="small">送迎変更</v-chip>
                    </template>
                  </template>
                </div>

                <div class="d-flex align-center">
                  <template v-if="attendance.comment && attendance.comment.comment">
                    <v-icon color="#E190CF">mdi-note-outline</v-icon>
                  </template>
                  <template v-if="attendance.chatUnreadCount > 0">
                    <v-chip color="primary" class="mx-2 pa-2" size="small">{{
                      attendance.chatUnreadCount
                    }}</v-chip>
                  </template>
                  <v-icon>mdi-chevron-right</v-icon>
                </div>
              </div>
            </v-list-item>
          </v-list>
        </div>
        <div v-else>
          <VueLoading :height="'50vh'" />
        </div>
      </v-tabs-window-item>

      <v-tabs-window-item  value="memo"> 
        <div v-if="!fetchLoading && clasSummary">
          <v-list v-for="(clas, index) in clasSummary" :key="index" density="compact">
            <v-list-subheader class="attendance-list-header d-flex align-center w-100"> 
              {{ clas.className }}
              <span v-if="clas.isInCharge" class="text-primary ml-6">担当クラス</span>
              <span class="ml-6">{{ clas.presentChildrenCount }}/{{ clas.totalChildrenCount }}</span>
            </v-list-subheader>
            
            <v-list-item v-for="(attendance, index) in clas.childrenAttendance" :key="index">
              <div class="d-flex align-center justify-space-between w-100 mt-2">
                <div>
                  {{ attendance.child.lastName }} {{ attendance.child.firstName }}
                  <template v-if="attendance.status === 1">
                    <v-chip color="primary" class="mx-2" variant="outlined" size="small">登園済み</v-chip>
                  </template>
                  <template v-if="attendance.status === 2">
                    <v-chip color="secondary" class="mx-2" variant="outlined" size="small">降園済み</v-chip>
                  </template>
                  <template v-if="attendance.absence === 1">
                    <v-chip color="grey" class="mx-2" variant="outlined" size="small">おやすみ</v-chip>
                  </template>
                  <template v-if="attendance.pickup">
                    <template v-if="attendance.pickup.dropOff.by || attendance.pickup.pickup.by">
                      <v-chip color="orange" class="mx-2" variant="outlined" size="small">送迎変更</v-chip>
                    </template>
                  </template>
                </div>
              </div>
              
              <div
                class="d-flex flex-column mt-2"
                style="width: 100%; overflow-wrap: anywhere; white-space:pre-line;"
              >
                <MemoForm
                  :comment="[
                    attendance.comment && attendance.comment.comment
                      ? attendance.comment.comment
                      : '',
                  ]"
                  :date="date"
                  :child="attendance.child"
                  @saveComment="showSnackBar"
                />
                <v-divider></v-divider>
              </div>
            </v-list-item>
          </v-list>
        </div>
        <div v-else>
          <VueLoading :height="'50vh'" />
        </div>
      </v-tabs-window-item >
    </v-tabs-window>

    <v-dialog v-model="absenceDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <AbsenceListModal
        :chatsAbsence="chatsAbsence"
        :isOpen="absenceDialog"
        @close="absenceDialog = false"
      />
    </v-dialog>

    <!-- Fab -->
    <div class="fab-wrapper">
    <v-slide-y-reverse-transition>
      <div v-show="isFabOpen" class="fab-items mb-4">
        <v-btn
          color="#6C6C6C"
          rounded="xl"
          size="large"
          class="mb-3 text-white"
          :to="`/communication/draft`"
          elevation="10"
          style="height: auto; min-height: 48px; white-space: normal;"
        >
          <span class="py-2 px-4">下書きを開く</span>
        </v-btn>

        <v-btn
          color="primary"
          rounded="xl"
          variant="outlined"
          size="large"
          class="mb-3 bg-white"
          :to="`/communication/ready-send-box`"
          elevation="10"
          style="height: auto; min-height: 48px; white-space: normal;"
        >
          <span class="py-2 px-4">送信準備BOXを開く</span>
        </v-btn>

        <v-btn
          color="primary"
          rounded="xl"
          size="large"
          class="mb-3"
          :to="`/communication/new-message`"
          elevation="10"
          style="height: auto; min-height: 48px; white-space: normal;"
        >
          <span class="py-2 px-4">一斉メッセージを作成</span>
        </v-btn>
      </div>
    </v-slide-y-reverse-transition>

    <v-btn
      color="primary"
      icon
      size="x-large"
      elevation="10"
      @click="isFabOpen = !isFabOpen"
    >
      <v-icon size="large">
        {{ isFabOpen ? 'mdi-close' : 'mdi-plus' }}
      </v-icon>
    </v-btn>
  </div>

    <v-snackbar v-model="snackbar" :timeout="timeout" outlined top color="primary">
      {{ snackBarText }}

      <!-- <template slot:action="{ attrs }">
        <v-btn color="primary" text bind="attrs" @click="snackbar = false">
          ×
        </v-btn>
      </template> -->
      <template v-slot:actions>
        <v-btn
          color="outline-primary"
          variant="text"
          @click="snackbar = false"
        >
          ×
        </v-btn>
      </template>
    </v-snackbar>
  </vue-pull-refresh>
    <v-dialog
      v-model="dateDialogFlg"
      width="auto"
    >
        <v-locale-provider locale="ja">
          <v-date-picker
            v-model="selectedDate"
            hide-header
            @update:model-value="dateSelected"
            color="primary"
            style="transform: scale(0.8);"
          >
          </v-date-picker>
        </v-locale-provider>
    </v-dialog>
  </div>
</template>
<script lang="ts">
//import Vue from 'vue';
import { defineComponent } from "vue";
import { meModule } from '@/store/dataModules/meModule';
import { attendanceModule } from '@/store/dataModules/attendanceModule';
import { nurseryModule } from '@/store/dataModules/nurseryModule';
import AttendanceList from '@/components/AttendanceList.vue';
import DatePager from '@/components/molecules/DatePager.vue';
import VueLoading from '@/components/pages/Loding.vue';
import AbsenceListModal from '@/components/molecules/AbsenceListModal.vue';
import MemoForm from '@/components/molecules/MemoForm.vue';

import { MeNurserySchoolResponse, MeResponse, NurseryChildResponse } from 'chaild-api/lib/index';
import { AbsenceChildType, ClassResponse, GetAttendanceSearchResponse } from '@/model/Response';
import { GetAttendanceSearchRequest, GetAttendanceRequest } from '@/model/Request';
import LocalDataService from '@/service/LocalDataService';

import dayjs from 'dayjs';
import ja from 'dayjs/locale/ja';
import { chatModule } from '@/store/dataModules/chatModule';
import VuePullRefresh from '@/components/pull/VPullRefresh.vue';
dayjs.locale(ja);

export default defineComponent({
  components: {
    VueLoading,
    AttendanceList,
    AbsenceListModal,
    DatePager,
    MemoForm,
    VuePullRefresh,
  },
  data: () => {
    return {
      fetchLoading: false,
      isFabOpen: false,
      date: dayjs(),
      tabIndex: 0,
      absenceDialog: false,
      snackbar: false,
      snackBarText: '',
      timeout: 2000,
      dateDialogFlg: false,
      selectedDate: dayjs().format('YYYY-MM-DD'),
      addflg: false,
      subtractflg: false,
      clasSummary: null as any,
    };
  },
  computed: {
    chatSummary() {
      console.log(`chatSummary: ${chatModule.chatSummary?.date}`)
      if (chatModule.chatSummary && chatModule.chatSummary.date === this.date.format('YYYY-MM-DD')) {
        this.setClasSummary();
        return chatModule.chatSummary;
      }
      return null;
    },
    /*
    clasSummary() {
      if (chatModule.chatSummary && chatModule.chatSummary.date === this.date.format('YYYY-MM-DD')) {
        const summaryies = chatModule.chatSummary.summaries;
        console.log(`summaryies: ${summaryies}`)
        const temp = summaryies.find(clas => clas.isInCharge === true);
        const index = summaryies.findIndex(clas => clas.isInCharge === true);
        if (temp && index && index > 0) {
          summaryies.splice(index, 1);
          summaryies.unshift(temp);
        }
        summaryies.map(summary => {
          const temp = summary.childrenAttendance.filter(
            childrenAttendance =>
              !childrenAttendance.child.quitDate ||
              childrenAttendance.child.quitDate > this.date.format('YYYY-MM-DD')
          );
          summary.childrenAttendance = temp;
          summary.totalChildrenCount = temp.length;
        });
        return summaryies;
      }
      console.log(`clasSummary: return null;`)
      return null;
    },
    */
    reTotalChildrenCount() {
      if (this.clasSummary) {
        let calc = 0;
        this.clasSummary.map(summary => {
          calc = calc + summary.childrenAttendance.length;
        });
        return calc;
      }
    },
    chatsAbsence(): AbsenceChildType[] | [] {
      if (chatModule.chatSummary && chatModule.chatSummary.date === this.date.format('YYYY-MM-DD')) {
        return chatModule.chatSummary.absences;
      }
      return [];
    },
    myClass(): ClassResponse | null {
      const user = LocalDataService.getUser();
      if (user && user.nurserySchools[0].class) {
        let nurserySchool = user.nurserySchools.find(nursery => nursery.isDefault === true);
        if (!nurserySchool) {
          nurserySchool = user.nurserySchools[0];
        }
        return nurserySchool.class;
      }
      return null;
    },
    me(): MeResponse | null {
      const me = LocalDataService.getUser();
      return me;
    },
    currentScool(): MeNurserySchoolResponse | undefined {
      if (this.me) {
        let nurserySchool = this.me.nurserySchools.find(nursery => nursery.isDefault === true);
        if (this.me.nurserySchools.length === 0) {
          return undefined
        }
        if (!nurserySchool) {
          nurserySchool = this.me.nurserySchools[0];
        }
        return nurserySchool;
      }
      return undefined;
    },
    features(): Array<{
      name: string; // 機能名
      slug: string; // 機能スラッグ
      isEnabled: boolean; // 機能有効フラグ
    }> {
      if (this.currentScool) {
        const messageFeature = this.currentScool.applicationPlan.nurseryMobile.featureGroups.find((fg) => fg.name === "連絡");
        if (!messageFeature) {
          return [];
        }
        return messageFeature.features.filter((f) => f.isEnabled);
      }
      return [];
    },
    shouldShowAttendance() {
      const find = this.features.find((f) => f.slug === "nursery-mobile-messaging-attendance");
      if (find) {
        return true;
      }
      return false;
    },
    shouldShowMemo() {
      const find = this.features.find((f) => f.slug === "nursery-mobile-messaging-attendance-note");
      if (find) {
        return true;
      }
      return false;
    },
  },
  watch: {
    date: {
      handler() {
        this.init();
      },
      deep: true,
    },
  },
  methods: {
    setClasSummary() {
      console.log(`chatModule.chatSummary.date: ${chatModule.chatSummary?.date}`)
      console.log(`this.date.format('YYYY-MM-DD'): ${this.date.format('YYYY-MM-DD')}`)
      if (chatModule.chatSummary && chatModule.chatSummary.date === this.date.format('YYYY-MM-DD')) {
        // ストアのデータを破壊しないようにディープコピーを作成
        const summaries = JSON.parse(JSON.stringify(chatModule.chatSummary.summaries));
        console.log(`summaryies: ${summaries}`);
        
        const temp = summaries.find((clas: any) => clas.isInCharge === true);
        const index = summaries.findIndex((clas: any) => clas.isInCharge === true);
        
        if (temp && index && index > 0) {
          summaries.splice(index, 1);
          summaries.unshift(temp);
        }
        
        summaries.map((summary: any) => {
          const temp = summary.childrenAttendance.filter(
            (childrenAttendance: any) =>
              !childrenAttendance.child.quitDate ||
              childrenAttendance.child.quitDate > this.date.format('YYYY-MM-DD')
          );
          summary.childrenAttendance = temp;
          summary.totalChildrenCount = temp.length;
        });
        
        this.clasSummary = summaries;
      } else {
        console.log(`clasSummary: return null;`);
        this.clasSummary = null;
      }
    },
    openDateDialog() {
      if (this.addflg || this.subtractflg) {
        this.addflg = false;
        this.subtractflg = false;
        return
      }
      this.selectedDate = this.date.format('YYYY-MM-DD');
      this.dateDialogFlg = true;
    },
    dateSelected(day) {
      this.date = dayjs(day);
      this.selectedDate = dayjs(day).format('YYYY-MM-DD');
      sessionStorage.setItem('communicationDate', this.date.format('YYYY-MM-DD'));
      this.dateDialogFlg = false;
    },
    showSnackBar(text: string) {
      this.snackBarText = text;
      this.snackbar = true;
    },
    predictFever(value: string | null | undefined) {
      if (value === 'FEVER') {
        return 'red';
      } else if (value === 'MODEST_FEVER') {
        return 'orange';
      } else {
        return null;
      }
    },
    addDay() {
      this.date = this.date.add(1, 'd');
      sessionStorage.setItem('communicationDate', this.date.format('YYYY-MM-DD'));
      this.addflg = true;
    },
    subtractDay() {
      this.date = this.date.subtract(1, 'd');
      sessionStorage.setItem('communicationDate', this.date.format('YYYY-MM-DD'));
      this.subtractflg = true;
    },
    async reload() {
      await new Promise<void>(resolve => setTimeout(() => resolve(), this.timeout));
      this.init(); //再読み込み
    },
    async init() {
      try {
        this.fetchLoading = true;
        const user = LocalDataService.getUser();
        if (user) {
          let nurserySchool = user.nurserySchools.find(nursery => nursery.isDefault === true);
          if (!nurserySchool) {
            nurserySchool = user.nurserySchools[0];
          }
          const nurseryId = nurserySchool.nurseryId;
          // await Promise.all([
          //   chatModule.getChatSummary({
          //     nurseryId,
          //     date: this.date.format('YYYY-MM-DD'),
          //   }),
          // ]);
          chatModule.getChatSummary({
            nurseryId,
            date: this.date.format('YYYY-MM-DD'),
          });
          // 修正：データ取得後にサマリーを計算してセットする
          this.setClasSummary();
        }
      } catch {
      } finally {
        this.$nextTick(() => {
          this.fetchLoading = false;
        });
      }
    },
  },
  async mounted() {
    const communicationDate = sessionStorage.getItem('communicationDate');
    if (communicationDate && this.date != dayjs(communicationDate)) this.date = dayjs(communicationDate);

    this.init();
  },
});
</script>
<style lang="scss" scoped>
@use '@/sass/variables.scss' as *;
@use '@/sass/ress.scss' as *;

.navigation-button {
  padding: 4px !important;
  font-weight: bold !important;
}

.navigation-date-small {
  font-weight: bold;
  font-size: 12px;
  text-align: center;
}

.navigation-date-large {
  font-weight: bold;
  font-size: 24px;
}

.attendance-summary-block {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.attendance-label-small {
  font-weight: bold;
  font-size: 12px;
  text-align: center;
}

.attendance-label-medium {
  font-weight: bold;
  font-size: 16px;
  text-align: center;
}

.attendance-label-large {
  font-weight: bold;
  font-size: 24px;
  text-align: center;
}

.attendance-list-header {
  background-color: #F5F6F6;
  height: 32px;
  font-weight: bold;
}

.fab-wrapper {
  position: fixed;
  bottom: 72px;
  right: 16px;
}

.fab-items {
  position: absolute;
  bottom: 64px;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.fever {
  color: white;
  .red {
    background-color: red;
  }
  .orange {
    background-color: orange;
  }
}
</style>
